export type SwapType = 'flight' | 'hotel' | 'car'

/**
 * Represents the steps involved in a swap operation.
 *
 * @enum SwapStep
 * @property {Select}   The initial step where the user selects the booking to swap.
 * @property {Review}   The review step where the user confirms the swap details.
 * @property {Complete} The final step indicating the result of the swap (either completed or rejected).
 */
export enum SwapStep {
  Select, // Swap
  Review, // Confirmation
  Complete, // Result: Complete | Reject
}

export enum SwapConfirmationStatus {
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Expired = 'Expired',
  New = 'New',
  Pending = 'Pending',
  Booked = 'Booked',
}
